import React from 'react'
import '../src/transferCard.scss'

const TransferCardHeader = ({ customers, date, leaseType, finalInspectionDoneAt, finalInspectionNeedsRechecking, showInspectionCardStatus}) => {

  const movers = (customers) => {
    if (!customers) {
      return ''
    }
    const names = customers.map((customer) => {
      return <div key={customer.id}><a href={("/admin/customers/"+ customer.id)} className="customer-link">{customer.first_name + ' ' + customer.last_name}</a></div>
    });
    return names
  };

  const options = { year: 'numeric', month: '2-digit', day: '2-digit'};
  const dateString = new Intl.DateTimeFormat('en-GB', options).format(Date.parse(date));

  const inspectionCardStatus = () => {
    if (showInspectionCardStatus) {
      return (
        <div className="card-item">
          <p>Huoneistotarkastus tehty</p>
          <strong>{finalInspectionDoneAt ? (finalInspectionNeedsRechecking ? "Vaatii uudelleentarkastuksen" : "Kyllä") : "Ei"}</strong>
        </div>
      )
    }
  }

  const leaseTypeText = () => {
    switch (leaseType) {
      case 'moving_in':
        return "Sisäänmuuttopäivä";
      case 'moving_out':
        return "Poismuuttopäivä";
      default:
        return "";
    }
  }

  return (
    <div className="card-row">
      <div className="card-item">
        {leaseTypeText()}
        <p>{dateString.replace(/\//g,'.')}</p>
      </div>
      <div className="card-item">
        <p>Asiakas</p>
        {movers(customers)}
      </div>
      {inspectionCardStatus()}
    </div>
  );
};

export default TransferCardHeader
